exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.filters-panel[data-v-6e882887] {\n  transition: all 0.3s ease;\n}\n\n/* Override Bootstrap's legacy [class*=\"span\"] selector for Tailwind grid */\n.grid [class*='col-span'][data-v-6e882887] {\n  float: none !important;\n  margin-left: 0 !important;\n  min-height: initial !important;\n}\n", ""]);

// exports
